import { Color } from '@/constants/color';
import Button from '@/ui/members/components/Button';
import Heading from '@/ui/members/components/Heading';

export const NotFound = () => {
  return (
    <div className="h-full w-full flex flex-col items-center justify-center min-h-screen bg-gray-900 text-white">
      <Heading level={1}>404</Heading>
      <p className="text-xl text-gray-400 mb-8">
        Oops! The page you are looking for does not exist.
      </p>
      <Button href="/members" color={Color.GREEN}>
        Go to Home
      </Button>
    </div>
  );
};
